import * as React from "react";
import { WithNamespaces, withNamespaces } from "react-i18next";
import { NoPrint } from "react-easy-print";
import { commentIdDnd } from "src/helpers/dragndrop";

export enum ControlBarEvents {
  ZoomIn,
  ZoomOut,
  ToggleFullScreen,
  Download,
  Print,
  Share
}

type ButtonName = "fscreen" | "zoom" | "pin" | "download" | "print" | "share";

interface Props {
  /**
   * Transmit click event on parent component, with a type specifying which buytton has been clicked
   */
  onEvent: (type: ControlBarEvents, data?: any) => void;

  /**
   * Currently active events, corresponding button will be colored in control bar
   */
  selected?: ControlBarEvents;
  /**
   * List of button want to display in control bar
   */
  buttons: ButtonName[];

  locked?: boolean;
}

type PropsWithNamespaces = Props & WithNamespaces;

class ControlBar extends React.Component<PropsWithNamespaces> {
  /**
   * When drag start on pin icon
   * we set it with a default comment id, so other components will now they have to create a comment
   */
  handlePinDragStart = (ev: React.DragEvent) => {
    ev.dataTransfer.setData("text/plain", commentIdDnd("0"));
  };
  render() {
    return (
      <NoPrint force={true}>
        <div className="control-bar">
          {this.props.buttons.indexOf("fscreen") > -1 && (
            <button
              onClick={() =>
                this.props.onEvent(ControlBarEvents.ToggleFullScreen)
              }
            >
              <img src="assets/svgs/outline-fullscreen.svg" />
              <small> {this.props.t("controlBar.fullscreen")}</small>
            </button>
          )}
          {this.props.buttons.indexOf("zoom") > -1 && (
            <div>
              <div>
                <button
                  className="m-0"
                  onClick={() => this.props.onEvent(ControlBarEvents.ZoomIn)}
                >
                  <img src="assets/svgs/outline-zoom_in.svg" />
                </button>
                <button
                  onClick={() => this.props.onEvent(ControlBarEvents.ZoomOut)}
                >
                  <img src="assets/svgs/outline-zoom_out.svg" />
                </button>
              </div>
              <small> {this.props.t("controlBar.zoom")}</small>
            </div>
          )}
          {/** Draggable icon: so we can pin comments on image */}
          {this.props.buttons.indexOf("pin") > -1 && !this.props.locked && (
            <div>
              <img
                src="assets/svgs/pin.svg"
                draggable={true}
                onDragStart={this.handlePinDragStart}
              />
              <small> {this.props.t("controlBar.update")}</small>
            </div>
          )}
          {this.props.buttons.indexOf("download") > -1 && (
            <button
              onClick={() => this.props.onEvent(ControlBarEvents.Download)}
            >
              <img src="assets/svgs/outline-cloud_download.svg" />
              <small>{this.props.t("controlBar.download")}</small>
            </button>
          )}
          {this.props.buttons.indexOf("share") > -1 && (
            <button onClick={() => this.props.onEvent(ControlBarEvents.Share)}>
              <img src="assets/svgs/share.svg" />
              <small>{this.props.t("controlBar.share")}</small>
            </button>
          )}
          {this.props.buttons.indexOf("print") > -1 && (
            <button onClick={() => this.props.onEvent(ControlBarEvents.Print)}>
              <img src="assets/svgs/outline-print.svg" />
              <small>{this.props.t("controlBar.print")}</small>
            </button>
          )}
        </div>
      </NoPrint>
    );
  }
}

export default withNamespaces()(ControlBar);



// WEBPACK FOOTER //
// ./src/components/ControlBar.tsx